var EmailFormCallClickView, EmailFormLiveChatClickView, EmailFormOptimizedContactChannelView, EmailFormV2FlexibleContactChannelsTextView, SharedFooterIntlPhoneNumberView, SupportEmailFormIntlV2FlexibleContactChannelsView, SupportEmailFormIntlVerticalView, SupportV1StepThreeBaseView, SupportVerticalINTLStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormIntlVerticalView = require('../../email_form/INTL/vertical_view');

SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SupportEmailFormIntlV2FlexibleContactChannelsView = require('../../email_form/INTL/v2_flexible_contact_channels');

EmailFormLiveChatClickView = require('../../email_form/common/live_chat_click_view');

EmailFormCallClickView = require('../../email_form/common/call_click_view');

EmailFormV2FlexibleContactChannelsTextView = require('../../email_form/common/v2_flexible_contact_channel_text_view');

SupportVerticalINTLStepThreeView = (function(superClass) {
  extend(SupportVerticalINTLStepThreeView, superClass);

  function SupportVerticalINTLStepThreeView() {
    return SupportVerticalINTLStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalINTLStepThreeView.prototype.className = 'vertical step-three';

  SupportVerticalINTLStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormIntlVerticalView(options);
  };

  SupportVerticalINTLStepThreeView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.callClickHandler();
      };
    })(this));
  };

  SupportVerticalINTLStepThreeView.prototype.callClickHandler = function() {
    if (!this.callClickView) {
      this.callClickView = new EmailFormCallClickView({
        phoneNumberView: this.getPhoneNumberView(this),
        contactChannelTextView: this.getContactChannelTextView(this)
      });
      this.callClickView.render();
      this.$el.html(this.callClickView.el);
      return this.callClickView.postRenderhandler();
    }
  };

  SupportVerticalINTLStepThreeView.prototype.getContactChannelTextView = function(stepThreeView) {
    return new EmailFormV2FlexibleContactChannelsTextView({
      mainView: stepThreeView,
      emailFormModel: stepThreeView.emailFormModel,
      showOnlyFlexibleText: true,
      isVertical: true,
      shouldShowCallBackFailureView: false
    });
  };

  SupportVerticalINTLStepThreeView.prototype.getPhoneNumberView = function(stepThreeView) {
    return new SharedFooterIntlPhoneNumberView({
      emailFormModel: stepThreeView.emailFormModel,
      renderPopup: false
    });
  };

  SupportVerticalINTLStepThreeView.prototype.shouldShowContactChannelView = function() {
    return !window.priorityViewsEnabled();
  };

  SupportVerticalINTLStepThreeView.prototype.configureContactChannelView = function(options) {
    return new SupportEmailFormIntlV2FlexibleContactChannelsView(options);
  };

  SupportVerticalINTLStepThreeView.prototype.renderEmailForm = function() {
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportVerticalINTLStepThreeView.prototype.renderProgressBar = function() {};

  SupportVerticalINTLStepThreeView.prototype.renderLegacyOrderBanner = function() {};

  SupportVerticalINTLStepThreeView.prototype.renderChatClickView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var liveChatClickView;
        if (_this.isFlexibleContactEnabled()) {
          liveChatClickView = new EmailFormLiveChatClickView();
          liveChatClickView.render();
          return _this.$el.html(liveChatClickView.el);
        }
      };
    })(this));
  };

  return SupportVerticalINTLStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportVerticalINTLStepThreeView;

//# sourceMappingURL=data:application/json;base64,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
